<template>
  <div>
    <a-modal
      :title="modalTitle"
      v-model="visible" 
      @cancel="handleCancel" 
      width="850px"
      v-bind:body-style="{ height: '450px',overflowY:'auto' }"
    >
    <!-- 表单 -->
    <div >
      <div style="width: 100%;display: flex;">
        <a-button
          type="primary"
          style="margin-right: 20px;"
          @click="handleDown"
        >
        {{ '下载模板' }}
      </a-button>
      <a-upload :file-list="fileList" :remove="handleRemove" :before-upload="beforeUpload" >
        <a-button :disabled="fileList.length > 0"> <a-icon type="upload" /> 选择导入内容 </a-button>
      </a-upload>
      </div>
      <!-- 表格 -->
      <a-table
        class="antd-table"
        bordered
        :columns="relevanceBatch_grid.field"
        :data-source="relevanceBatch_grid.row"
        rowKey="id"
        size="small"
        :scroll="{x:relevanceBatch_grid.width}"
        :pagination="false"
        :loading="tableLoading"
        style="margin-top: 20px;"
        :rowClassName="setRowClassName"
      >
        <!-- 序号 -->
        <span slot="index" slot-scope="text, record, index">
          {{index + 1}}
        </span>
      </a-table>
    </div>
    <template #footer>
      <!-- 底部按钮区域 -->
      <a-button  type="primary" ghost @click="handleCancel">取消</a-button>
      <a-button  type="primary" @click="handleOk">确定</a-button>
    </template>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment';
import { downloadAccount,addBatchMember,importAccount } from "@/api/api.js";
export default {
  components: {
  },
  props: {
    modalTitle: {
      type: String,
      default: () => "",
    }, //标题
    memberId:{type:String,  default: () => ""},//会员ID
    data: {
      type: Object,
      default: () => {},
    },//返回信息
  },

  data() {
    return {
      visible: true,
      fileList: [],
      uploading: false,

      //查询加载
      tableLoading:false,
      relevanceBatch_grid: {
          height: 0,
          width: 0, // 宽度
          row: [],
          field: [
            {
              title: "序号",
              align: "center",
              width: 50,
              dataIndex: "index",
              ellipsis: true,
              scopedSlots: {
                customRender: "index",
              },
            },
            {
              title: "所属企业",
              align: "center",
              width: 130,
              dataIndex: "comName",
              ellipsis: true,
            },
            {
              title: "姓名",
              align: "center",
              width: 160,
              dataIndex: "accountName",
              ellipsis: true,
            },
            {
              title: "联系方式",
              colSpan: 1,
              align: "center",
              width: 100,
              ellipsis: true,
              dataIndex: "phoneNo",
            },
            {
              title: "充值金额",
              colSpan: 1,
              align: "center",
              width: 140,
              ellipsis: true,
              dataIndex: "amount",
            },
            {
              title: "身份证号",
              colSpan: 1,
              align: "center",
              width: 120,
              ellipsis: true,
              dataIndex: "idCard",
            },
          ]
        },
    }
  },

  mounted() {
   
  },
  methods: {
    // 匹配行加底色
    setRowClassName(record, index) {
      if(record.isOk == false){
        // 如果是最后的汇总则无颜色
          return 'cell-class'
      } else {
        return '' 
      }
   },
    //下载模板
    handleDown() {
      downloadAccount().then(res => {
      }, (err) => {
          this.$message.error(err.message || '下载失败！')
        });
    },
    handleRemove(file) {
      this.relevanceBatch_grid.row = [];
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    beforeUpload(file) {
      if (file.name != null && file.name != '' && file.name != undefined) {
        let parts = file.name.split('.');
        let gs = parts.length > 1 ? parts[1] : '';
        if (gs != 'xls') {
          this.$message.warning("请检查文件格式，与需求不符！")
          return false;
        }
      }
      let form = new FormData();
      form.append("file", file);
      this.tableLoading = true;
      importAccount(form).then((res) => {
        if (res.content && res.content.length) {
          this.relevanceBatch_grid.row = res.content;
        } else {
          this.relevanceBatch_grid.row = [];
        }
        this.tableLoading = false;
        this.fileList = [...this.fileList, file];
      }, (err) => {
        this.handleRemove(file)
        this.tableLoading = false;
      });
      return false;
    },
    //取消
    handleCancel() {
      //关闭弹窗
      this.$emit("close");
    },

    //保存
    handleOk() {
      if (this.relevanceBatch_grid.row.length > 0) {
        const index = this.relevanceBatch_grid.row.findIndex(element => element.isOk == false);
        console.log("indexindenx",index)
        if (index >= 0) {
          this.$message.warning("红色背景数据列存在异常，请检查修改后重新上传！")
        } else {
          addBatchMember(this.relevanceBatch_grid.row).then((res) => {
            this.$message.success(res.message || "导入成功！");
            this.$emit("handleOk");
          });
        }
      } else {
        this.$message.warning("请上传导入文件！")
      }
    },

  },
}
</script>

<style lang="less" scoped>
.button-save {
  border: none;
  background: #009de5;
  color: #fff;
  width: 90px;
  height: 30px;
}

.button-cancel {
  border: 1px #cccccc solid;
  background: #fff;
  color: #333;
  width: 90px;
  height: 30px;
}
/deep/ .ant-table-small > .ant-table-content > .ant-table-body {
    margin: 0 !important;
}

/deep/ .cell-class{
  background-color: red !important;
}
</style>
